import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import {TABLET_BREAKPOINT} from '../../../utils/constants';
import {getValue, TESTS} from '../../../utils/abacus';

export function mapStateToProps(state) {
    return {
        abacus: state.abacus
    };
}

export class PriceLabelComponent extends PureComponent {
    render() {
        const {
            text,
            abacus
        } = this.props;

        const priceTestValue = getValue(abacus, TESTS.SLP_PROPERTY_TYPE_PRICES);
        return (
            <span className={priceTestValue === 1 ? 'RatioCard__priceLabel__banner' : 'RatioCard__priceLabel__subheading'} dangerouslySetInnerHTML={{__html: text}} />
        );
    }
}

export const PriceLabel =
    connect(mapStateToProps)(determineIfMobile(PriceLabelComponent, TABLET_BREAKPOINT));


export default PriceLabel;